import { ReportActionTypes } from "./report.types";

const INITAIL_STATE = {
  //student workbook

  studentWorkBookData: null,
  isFetchingStudentWorkBook: true,
  errorFetchingStudentWorkBook: null,
};

const assignmentReducer = (state = INITAIL_STATE, action) => {
  switch (action.type) {
    //report assignment detail

    case ReportActionTypes.SET_QUESTION_GRADE:
      let allQuestions = [];
      allQuestions = [
        ...state.studentWorkBookData.questionList.slice(
          0,
          action.payload.index
        ),
        action.payload.question,
        ...state.studentWorkBookData.questionList.slice(
          action.payload.index + 1,
          state.studentWorkBookData.questionList.length
        ),
      ];
      const data = { ...state.studentWorkBookData, questionList: allQuestions };
      return {
        ...state,
        studentWorkBookData: data,
      };

    default:
      return state;
  }
};

export default assignmentReducer;
